import React from 'react';
import { Link } from 'react-router-dom';
import { Image } from 'semantic-ui-react';
import { makeClassName } from '../functions/ui';
import { useSelector } from 'react-redux';

const BrandLink = React.memo(({ className }) => {
	const { url } = useSelector(state => state.platform);
	const { externalId } = useSelector(state => state.accounting);

	const computedUrl = externalId
		? `https://${url}/app/enterprises/${externalId}/dashboard`
		: `/`;

	return (
		<div className={makeClassName('brand', 'relative-parent', className)}>
			<Link to={computedUrl} className="extended">
				<Image src="/logo.svg" alt="Logo de MY.Compta" />
				<Image src="/small-logo.svg" alt="Logo de MY.Compta" className="small" />
				<span className="sr-only">MY.Compta</span>
			</Link>
		</div>
	);
});

export default BrandLink;
